<template>
  <div class="totals">
    <div class="totals--amount">
      <span class="totals--amount--name gray">{{ $gettext('TOTAL') }}</span>
      <div class="totals--amount--amount green">{{ distance }} km</div>
    </div>
    <div v-if="excluded" class="totals--amount">
      <span class="totals--amount--name gray">{{ $gettext('NOT SHOWN') }}</span>
      <div class="totals--amount--amount">{{ excluded }}</div>
    </div>
    <div v-if="gapKm !== '0'" class="totals--amount">
      <span class="totals--amount--name gray">{{ $gettext('ODOMETER GAP') }}</span>
      <div class="totals--amount--amount">{{ gapKm }} km</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TripReportTotals',
  props: {
    distance: {
      type: String,
      default: '',
    },
    excluded: {
      type: Number,
      default: 0,
    },
    gapKm: {
      type: String,
      default: '0',
    },
  },
}
</script>

<style lang="scss" scoped>
.gray {
  color: #777777;
}
.totals {
  display: flex;
  flex-wrap: wrap;
  &--amount {
    font-family: 'DINNextLTPro-Medium';
    font-size: 20px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    flex-grow: 0;
    flex-direction: column;
    padding-left: 14px;
    line-height: 1;
    white-space: nowrap;
    &--name {
      text-align: right;
      font-size: 65%;
      text-transform: uppercase;
      margin-bottom: 7px;
    }
    &--amount {
      line-height: 0.7;
    }
  }
}
@media (min-width: '768px') {
  .totals {
    justify-content: flex-end;
  }
}
@media (min-width: '992px') {
  .totals--amount {
    font-size: 20px;
  }
}
</style>
